const User = "UsuarioGenesis";
const ProductManager = "ProductManager";
const SystemAdministrator = "UserAdmin";
const TechnicalOffice = "OfTecnica";

export default { User, ProductManager, SystemAdministrator, TechnicalOffice };